import axios, { AxiosRequestConfig } from 'axios';

import { PATH_TO_CORE_API } from '@shared/constants';

export const ClientActionsApi = {
  async trackEvent(event: string, options?: AxiosRequestConfig): Promise<void> {
    return axios.post(`${PATH_TO_CORE_API}/clientActions/trackEvent/${event}`, undefined, options);
  },
};
